import $i from "~/i18n";
import router from "~/routes.js";

export const submitForm = async ({ commit }, payload) => {
  try {
    commit("notifications/waiteUpload", {}, { root: true });
    let body = { ...payload };
    var formData = new FormData();
    for (const key in body) {
      formData.append(key, body[key]);
    }
    let { data } = await axios.post("/become-instructor/sendform", formData, {
      onUploadProgress: function(progressEvent) {
        commit("SET_DATA", {
          data: parseInt(
            Math.round((progressEvent.loaded * 100) / progressEvent.total)
          ),
          id: "uploadPercentage"
        });
      }
    });
    if (data.state === 403) {
      commit(
        "notifications/error",
        { message: "ابتدا پروفایل خورد را تکمیل کنید", title: "" },
        { root: true }
      );
      return;
    }
    if (data.state === 500) {
      commit(
        "notifications/error",
        {
          message: "some keys missed , or some errors happened on server",
          title: "500"
        },
        { root: true }
      );
    }
    if (data.state !== 200) return;
    // context.commit('setPost', data.posts)
    commit(
      "notifications/success",
      { message: "درخواست شما ثبت شد", title: "ثبت درخواست" },
      { root: true }
    );
    router.push("/");
    // console.log(data);
  } catch (error) {
    commit(
      "notifications/error",
      { message: error, title: "" },
      { root: true }
    );
    console.log(error);
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/instructor-form/actions.js